import { Toggle } from '@honeyscience/honey-ui-toolkit';
import React, { ReactElement, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { PageDetectorNames } from 'mockStores/lib/types';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '8px',
  },
  hiddenElement: {
    display: 'hidden',
  },
  name: {
    paddingRight: '8px',
  },
  row: {
    alignItems: 'center',
    composes: 'label2',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
});

type PageDetectorToggleProps = {
  pageDetectorName: PageDetectorNames;
};

function PageDetectorToggle({ pageDetectorName }: PageDetectorToggleProps): ReactElement {
  const classes = useStyles();

  const localStorageKey = `mockStores:pageType-${pageDetectorName}`;
  const localStorageSetting = localStorage.getItem(localStorageKey);

  const [isOn, setIsOn] = useState<boolean>(localStorageSetting ? localStorageSetting === '1' : true);

  const onToggle = () => {
    localStorage.setItem(localStorageKey, isOn ? '0' : '1');
    setIsOn(!isOn);
  };

  return (
    <div className={ classes.container }>
      <div className={ classes.row }>
        <div className={ classes.name }>
          { pageDetectorName }
        </div>
        <Toggle id={ `${pageDetectorName}-toggle` } isOn={ isOn } onToggle={ onToggle } size={ 24 } />
      </div>
      { isOn &&
        <div id={ `${pageDetectorName}-enabled` } className={ classes.hiddenElement } /> }
    </div>
  );
}

export default PageDetectorToggle;
